import{Checkbox as e}from"./src/Checkbox.js";customElements.define("sp-checkbox",e);
//# sourceMappingURL=sp-checkbox.js.map
